import { useCallback } from "react";

import { useTenantSetting } from "@nestoca/multi-tenant";
import {
  BASIC_APPLICATION_TYPE_MAP,
  TRANSACTION_TYPE_LABEL,
  TransactionTypeEnum,
} from "@shared/constants";

import { getApplicationTypeByTransactionType } from "./applications";

/**
 *
 * @param application
 * @returns remapped transaction type and transaction type label based on the remapped transaction type
 */
export const useGetApplicationMetadata = () => {
  const { value: isRenewalSplitMigrationEnabled } = useTenantSetting(
    "renewalSplitMigration"
  );

  const getRemappedTransactionType = useCallback(
    (transactionType: TransactionTypeEnum) => {
      return isRenewalSplitMigrationEnabled
        ? getApplicationTypeByTransactionType(
            transactionType,
            BASIC_APPLICATION_TYPE_MAP
          )
        : transactionType;
    },
    [isRenewalSplitMigrationEnabled]
  );

  const getTransactionTypeLabel = useCallback(
    (transactionType: TransactionTypeEnum) => {
      return TRANSACTION_TYPE_LABEL[
        getRemappedTransactionType(transactionType)
      ];
    },
    [getRemappedTransactionType]
  );

  return {
    isRenewalSplitMigrationEnabled,
    getRemappedTransactionType,
    getTransactionTypeLabel,
  };
};
